import React, {useEffect, useRef, useState} from "react";
import styles from "./chat.module.css";
import {Header} from "../header/header";
import {ChatContainer} from "../chat-container/chat-container";
import {Assistant} from "../assistant/assistant";
import {useDispatch, useSelector} from "react-redux";
import {addResponse, clearOraculIsTyping, clearWaitingResponse, setOraculIsTyping,} from "../../store/stateSlice";
import {answers as oracularAnswers} from "../../messages";
import {MessageOracular} from "../message-oracular/message-oracular";
import {MessageUser} from "../message-user/message-user";
import {renderString} from "../../../../util";

const Chat = () => {
  const messages = useSelector((store) => store.tarotChat.messages);
  const waitingResponse = useSelector((store) => store.tarotChat.waitingResponse);
  const isOracularTyping = useSelector((store) => store.tarotChat.isOracularTyping);
  const name = useSelector((store) => store.tarotChat.name);
  const zodiacSign = useSelector((store) => store.tarotChat.zodiacSign);
  const dispatch = useDispatch();
  const [currentAnswerIdx, setCurrentAnswerIdx] = useState(0);
  const messagesEndRef = useRef(null);

  const [answers, setAnswers] = useState(oracularAnswers);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ block: "end", behavior: "smooth" });
  };

  const renderOracularMessage = (oracularMessage) => {
    return oracularMessage.message.map((m) => {
      if (typeof m === 'string') {
        return renderString(m, {
          name: name,
          zodiacSign: zodiacSign,
        });
      }
      return m;
    })
  };

  const renderOracularMessagesStartingFrom = async (idx) => {
    const sleep = async (ms) => {
      return await new Promise((res) => setTimeout(res, ms));
    };

    let localIdx = idx;
    let answer = answers[localIdx];
    let hasNext = false;

    do {
      dispatch(setOraculIsTyping());
      // eslint-disable-next-line no-loop-func
      setTimeout(() => {
        dispatch(addResponse(renderOracularMessage(answer)));
        dispatch(clearOraculIsTyping());
      }, answer.delay || 1000);

      await sleep(answer.delay || 1000);

      if (answer.sendNext === true) {
        localIdx = localIdx + 1;
        answer = answers[localIdx];
        hasNext = true;
      } else {
        localIdx = localIdx + 1;
        hasNext = false;
      }
    } while (hasNext === true);

    return localIdx;
  };

  useEffect(() => {
    renderOracularMessagesStartingFrom(currentAnswerIdx)
      .then((idx) => setCurrentAnswerIdx(idx))
      .finally(dispatch(clearWaitingResponse()));
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, isOracularTyping]);

  const postResponse = () => {
    renderOracularMessagesStartingFrom(currentAnswerIdx)
      .then((idx) => setCurrentAnswerIdx(idx))
      .finally(dispatch(clearWaitingResponse()));
  };

  useEffect(() => {
    if (waitingResponse && currentAnswerIdx < answers.length) {
      postResponse();
    }
  }, [waitingResponse]);

  return (
    <div className={styles.chat}>
      <Header />
      <Assistant />
      <ChatContainer>
        {messages.map((message, idx) =>
          message.sender === "oracular" ? (
            <MessageOracular key={idx}>{message.text}</MessageOracular>
          ) : (
            <MessageUser key={idx}>{message.text}</MessageUser>
          )
        )}
        {isOracularTyping && (
          <div className={styles.typing_container}>
            <div className={styles.typing_dot}></div>
            <div className={styles.typing_dot}></div>
            <div className={styles.typing_dot}></div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </ChatContainer>
    </div>
  );
};

export { Chat };
